module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "scrollable": "",
      "content-class": ("rate-card-modal " + (_vm.currentMode === 'edit' ? 'rate-card-modal--edit' : '')),
      "width": _vm.currentMode === 'edit' ? '1500px' : '1000px'
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      View Rate Card Form\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "rate-card-modal__controls"
  }, [_c('div', [_c('v-row', {
    staticClass: "text-right"
  }, [_c('v-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [(_vm.currentMode === 'detail') ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('edit')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("edit")]), _vm._v("\n              Edit\n            ")], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('v-btn', {
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeMode('detail')
      }
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": ""
    }
  }, _vm.on), [_vm._v("close")]), _vm._v("\n              Cancel Edit\n            ")], 1) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), (_vm.currentMode === 'detail') ? _c('v-card-text', {
    staticClass: "bg-white rate-card-modal__body"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.name ? _vm.data.name : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.email ? _vm.data.email : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Date of Birth")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.dateOfBirth ? _vm.utils.formatCustomDate(_vm.data.dateOfBirth, 'DD/MM/YYYY') : '-') + "\n          ")])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Ethnicity")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.ethnicity && _vm.data.ethnicity !== 'Others' ? _vm.data.ethnicity : '')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.otherEth ? _vm.data.otherEth : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.country ? _vm.data.country : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.city ? _vm.data.city : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Gender")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.gender ? _vm.data.gender : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.contactNo ? _vm.data.contactNo : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("What is your occupation?")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.occupation || '-') + "\n          ")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Instagram Handle")]), _vm._v(" "), (_vm.data.instagramHandle) ? _c('social-handle', {
    attrs: {
      "isInstagram": true,
      "instagramHandle": _vm.data.instagramHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.data.instagramHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Tiktok Handle")]), _vm._v(" "), (_vm.data.tiktokHandle) ? _c('social-handle', {
    attrs: {
      "isTikTok": true,
      "tiktokHandle": _vm.data.tiktokHandle
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.data.tiktokHandle) ? _c('div', [_vm._v("-")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Your IG Followers Count")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.igFollowerCount ? _vm.data.igFollowerCount : '-')))])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Your TikTok Followers Count")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.tiktokFollowerCount ? _vm.data.tiktokFollowerCount : '-')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("LinkedIn Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'linkedin')) ? _c('social-handle', {
    attrs: {
      "isLinkedIn": true,
      "linkedinHandle": _vm.getStandaloneHandle(_vm.data, 'linkedin')
    }
  }) : _c('div', [_vm._v("-")])], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Followers (Connections)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.linkedinFollowerCount || '-'))])])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("X (Twitter) Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'twitter')) ? _c('social-handle', {
    attrs: {
      "isTwitter": true,
      "twitterHandle": _vm.getStandaloneHandle(_vm.data, 'twitter')
    }
  }) : _c('div', [_vm._v("-")])], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("X (Twitter) Followers")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.twitterFollowerCount || '-'))])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("Facebook Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'facebook')) ? _c('social-handle', {
    attrs: {
      "isFacebook": true,
      "facebookHandle": _vm.getStandaloneHandle(_vm.data, 'facebook')
    }
  }) : _c('div', [_vm._v("-")])], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Facebook Followers")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.facebookFollowerCount || '-'))])])]), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("YouTube Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'youtube')) ? _c('social-handle', {
    attrs: {
      "isYoutube": true,
      "youtubeHandle": _vm.getStandaloneHandle(_vm.data, 'youtube')
    }
  }) : _c('div', [_vm._v("-")])], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("YouTube Followers")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.youtubeFollowerCount || '-'))])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2 rate-card-platform-detail",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('div', [_c('label', [_vm._v("Twitch Handle")]), _vm._v(" "), (_vm.getStandaloneHandle(_vm.data, 'twitch')) ? _c('a', {
    attrs: {
      "href": ("https://www.twitch.tv/" + (_vm.getStandaloneHandle(_vm.data, 'twitch'))),
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "#9146FF"
    }
  }, [_vm._v("mdi-twitch")]), _vm._v(" @" + _vm._s(_vm.getStandaloneHandle(_vm.data, 'twitch')) + "\n            ")], 1) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Twitch Followers")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.data.twitchFollowerCount || '-'))])])])], 1), _vm._v(" "), _c('v-row', [(_vm.data.engagement) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Engagement")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.engagement ? (_vm.data.engagement | _vm.thousandSeprator) : '-')))])]) : _vm._e(), _vm._v(" "), (_vm.data.views) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('label', [_vm._v("Views")]), _vm._v(" "), _c('div', [_vm._v(_vm._s((_vm.data.views ? (_vm.data.views | _vm.thousandSeprator) : '-')))])]) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Content Type")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Ordinary Rate")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Preferential rate")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Story")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igStory || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igStory) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igStoryCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igStory || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igStory) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igStoryCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igPost || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igPost) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igPostCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igPost || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igPost) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igPostCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igCarousel || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igCarousel) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igCarouselCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igCarousel || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igCarousel) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igCarouselCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("IG Reel")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.igReel || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.igReel) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.igReelCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.igReel || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.igReel) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.igReelCurrency || 'SGD'))]) : _vm._e()])])])]
      },
      proxy: true
    }], null, false, 188216484)
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (Instagram)")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.data.igRemarks))
    }
  })])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-simple-table', {
    staticClass: "tiktok-stats",
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Tiktok")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.tiktok || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.tiktok) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.tiktokCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.tiktok || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.tiktok) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.tiktokCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("LinkedIn Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'linkedin', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'linkedin', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'linkedin', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'linkedin', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'linkedin', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'linkedin', 'preferential')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("X (Twitter) Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'twitter', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'twitter', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'twitter', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'twitter', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'twitter', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'twitter', 'preferential')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Facebook Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'facebook', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'facebook', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'facebook', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'facebook', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'facebook', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'facebook', 'preferential')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("YouTube Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'youtube', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'youtube', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'youtube', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'youtube', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'youtube', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'youtube', 'preferential')))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "pl-0"
        }, [_vm._v("Twitch Post")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'twitch', 'ordinary') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'twitch', 'ordinary')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'twitch', 'ordinary')))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.getStandaloneRate(_vm.data, 'twitch', 'preferential') || '-'))]), _vm._v(" "), (_vm.getStandaloneRate(_vm.data, 'twitch', 'preferential')) ? _c('span', [_vm._v(_vm._s(_vm.getStandaloneCurrency(_vm.data, 'twitch', 'preferential')))]) : _vm._e()])])])]
      },
      proxy: true
    }], null, false, 2518230305)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Remark (TikTok)")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.data.tiktokRemarks))
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-divider', {
    staticClass: "ma-0"
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Handle of Other Platforms")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Platform")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Rate")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getOtherPlatforms(_vm.data)), function(item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [(_vm.getPlatformKey(item.platform) === 'linkedin') ? _c('v-icon', {
            attrs: {
              "color": "#0A66C2",
              "small": ""
            }
          }, [_vm._v("mdi-linkedin")]) : (_vm.getPlatformKey(item.platform) === 'twitter') ? _c('img', {
            staticClass: "mr-1",
            attrs: {
              "src": "/static/img/x-logo.svg",
              "width": "14",
              "alt": "X (Twitter)"
            }
          }) : _vm._e(), _vm._v("\n                        " + _vm._s(_vm.getPlatformLabel(item.platform)) + "\n                        "), (item.platform === 'others') ? _c('span', [_vm._v(_vm._s(item.otherPlatform))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.url))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.rate))]), _vm._v(" "), (item.rate) ? _c('span', [_vm._v(_vm._s(item.rateCurrency || 'SGD'))]) : _vm._e()])])
        }), 0)]
      },
      proxy: true
    }], null, false, 1752233488)
  })], 1), _vm._v(" "), (_vm.data.pricingDecks && _vm.data.pricingDecks.length > 0) ? _c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Media Kit")]), _vm._v(" "), _c('file-preview', {
    attrs: {
      "files": _vm.data.pricingDecks
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("Common Fees")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Fee Type")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Ordinary Rate")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Preferential Rate")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Event Attendance")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.eventAppearance || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.eventAppearance) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.eventAppearanceCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.eventAppearance || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.eventAppearance) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.eventAppearanceCurrency || 'SGD'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Loading Fee")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.ordinaryRates.loadingFee || '-'))]), _vm._v(" "), (_vm.data.ordinaryRates.loadingFee) ? _c('span', [_vm._v(_vm._s(_vm.data.ordinaryRates.loadingFeeCurrency || 'SGD'))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.data.preferentialRates.loadingFee || '-'))]), _vm._v(" "), (_vm.data.preferentialRates.loadingFee) ? _c('span', [_vm._v(_vm._s(_vm.data.preferentialRates.loadingFeeCurrency || 'SGD'))]) : _vm._e()])])])]
      },
      proxy: true
    }], null, false, 3454867861)
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("The Client may be looking to load your content on social media for a duration not more than 30 days, are you agreeable to this arrangement?")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.loadContent || '-') + "\n          ")]), _vm._v(" "), (_vm.data.loadContentText) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.data.loadContentText) + "\n          ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Would you like to be part of our PR or gifting collaborations with brands?")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.giftBrand || '-') + "\n          ")])])], 1), _vm._v(" "), (_vm.data.keywords) ? _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("Preferred type of campaigns/genre (please tick relevant)")]), _vm._v(" "), _c('div', _vm._l((_vm.data.keywords), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_vm._v("\n              " + _vm._s(_vm.transPreferredEng(item) || '-') + "\n            ")])
  }), 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.data.aboutYou) ? _c('v-row', [_c('v-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('label', [_vm._v("A short description of your profile that best represents you")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.data.aboutYou || '-') + "\n          ")])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.currentMode === 'edit') ? _c('div', {
    staticClass: "edit-rate-card-form rate-card-modal__body"
  }, [_c('rate-card-form', {
    attrs: {
      "value": _vm.rateCardDialog,
      "mode": "edit",
      "editData": _vm.editData
    },
    on: {
      "updated": _vm.updatedRateCardForm
    },
    model: {
      value: (_vm.rateCardDialog),
      callback: function($$v) {
        _vm.rateCardDialog = $$v
      },
      expression: "rateCardDialog"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d85d83a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/RateCard/ViewModalDialog.vue
// module id = 2299
// module chunks = 0